import { FC } from 'react';
import { AdvertServiceDataType, useBotDetectorContext } from '@edikk-edikk/country-frontend';
import modelDetailParameterCss from '#advertDetail/assets/model-detail/model-detail-parameter.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  serviceData: AdvertServiceDataType;
};

const ServicePrice: FC<PropsType> = ({
  serviceData,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (!serviceData.price) {
    return null;
  }

  return (
    <div className={modelDetailParameterCss.modelDetailParameter__price}>
      (+
      {serviceData.price}
      )
    </div>
  );
};

export { ServicePrice };
